export const TheLondonPalladium = {
  basketNote: {},
  colors: {
    venueLogoBackgroundColor: '#f2bf6c'
  },
  themeVenueLogo: 'palladium_sw_icon.png',
  themeVenueName: 'The London Palladium',
  themeVenueAddress: '8 Argyll St, London W1F 7TF'
}
